import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-1" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm divide-y dark:divide-gray-900" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, " This farm has low liquidity ")
  ])
], -1)

import { computed } from 'vue';
import useNumbers from '@/composables/useNumbers';
import { DecoratedPool } from '@/services/balancer/subgraph/types';
import { bnum } from '@/lib/utils';

/**
 * TYPES
 */
type Props = {
  pool: DecoratedPool;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true }
  } as unknown as undefined,
  setup(__props: {
  pool: DecoratedPool;
}) {

const props = __props


/**
 * COMPOSABLES
 */
const { fNum } = useNumbers();

const hasThirdPartyAPR = computed(() =>
  bnum(props.pool.apr.thirdPartyApr).gt(0)
);

console.log("xploited", props.pool.apr)

return (_ctx: any,_cache: any) => {
  const _component_BalTooltip = _resolveComponent("BalTooltip")!

  return (_openBlock(), _createBlock(_component_BalTooltip, {
    width: "auto",
    noPad: ""
  }, {
    activator: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (Number(props.pool.totalLiquidity) < 10000)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require('@/assets/images/warning.png'),
              style: {"width":"16px","height":"16px"}
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_3
    ]),
    _: 1
  }))
}
}

})